const VctDividendReinvestmentEnum = Object.freeze({
    NONE: 'NONE',
    DRIP: 'DRIP',
    DRIS: 'DRIS'
});

export default VctDividendReinvestmentEnum;
